import { useState, useContext } from 'react';
import useNetworkLoader from 'hooks/useNetworkLoader';
import ConfigContext from 'Shared/ConfigContext';
import { addPanier } from 'Shared/ConfigContext/Actions';
import { addCart } from 'Services';

export default function useAddCart({ onSuccess } = {}) {
  const { dispatch } = useContext(ConfigContext);
  const { callApi } = useNetworkLoader();
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [adding, setAdding] = useState(false);

  const handleAddCart = (name) => {
    setAdding(true);
    callApi(
      () => addCart(name),
      (cartId) => {
        dispatch(addPanier(name, cartId));
        setAdding(false);
        setShowAddDialog(false);
        if (onSuccess) onSuccess();
      },
      false,
      () => { setAdding(false); },
    );
  };

  return {
    showAddDialog,
    setShowAddDialog,
    adding,
    handleAddCart,
  };
}
